"use client";
import { useTranslations } from "next-intl";
import useFilterContext from "../../theme/hooks/useFilterContext";
import AutoFilter from "./AutoFilter";
import FreeTextFilterCard from "../../theme/components/FreeTextFilterCard";
import useAssortmentProducts from "../hooks/useAssortmentProducts";
import ChildAssortmentFilterCard from "../../theme/components/ChildAssortmentFilterCard";
import useAssortmentChildren from "../hooks/useAssortmentChildren";

const AssortmentFilters = ({ assortmentId }) => {
  const t = useTranslations();
  const { formState } = useFilterContext();
  const { filters } = useAssortmentProducts({
    assortmentId,
    formState,
  });
  const { assortment } = useAssortmentChildren({ assortmentId });

  return (
    <>
      <ChildAssortmentFilterCard
        title={t("categories")}
        assortmentChildren={assortment?.children}
      />
      {filters?.map(({ definition, options }) => (
        <AutoFilter
          key={definition.key}
          definition={definition}
          options={options}
        />
      ))}
      <FreeTextFilterCard
        searchParamName="search"
        placeholder={t("products_search")}
      />
    </>
  );
};

export default AssortmentFilters;
